import React, {Component} from 'react'

class TableNoItem extends Component {
    render() {
        return (
            <tr className='TableNoItem'>
                <td colSpan={15}>Không có dữ liệu</td>
            </tr>
        )
    }
}

export default TableNoItem